"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _CollapsibleCard = require("./CollapsibleCard");
Object.keys(_CollapsibleCard).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CollapsibleCard[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CollapsibleCard[key];
    }
  });
});